// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hub-tournament-matches-widget__container {
    margin-bottom: var(--space-x2);
}

.hub-tournament-matches-widget__matches-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}

.hub-tournament-matches-widget__matches__match {
    padding: 10px 12px;
    border-radius: 8px;
    background: var(--white-color);
}

.hub-tournament-matches-widget__tournament_info {
    display: flex;
    align-items: center;
    /* background: var(--new-background-color);
    padding: 2px 4px;
    border-radius: 2px; */
    cursor: pointer;
}

.hub-tournament-matches-widget__tournament_info img {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    margin-right: 4px;
}

.hub-tournament-matches-widget__tournament_info .icon-ball {
    color: var(--white-color );
    font-size: 18px;
    border-radius: 50%;
    padding: 2px;
    margin-right: 4px;
}

.hub-tournament-matches-widget__tournament_info .baloa-table-column {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.hub-tournament-matches-widget__matches__match-date {
    background-color: var(--new-background-color);
    border-radius: 2px;
    width: fit-content;
    padding: 2px;
    margin-top: 6px;
    cursor: pointer;
}

.hub-tournament-matches-widget__matches__match-date.baloa-username {
    color: var(--primary-very-dark-color);
}

.hub-tournament-matches-widget__matches__match-team {
    display: flex;
    align-items: center;
    margin-top: 10px;
    cursor: pointer;
}

.hub-tournament-matches-widget__matches__match-team .icon-ball {
    color: var(--white-color );
    font-size: 24px;
    border-radius: 50%;
    padding: 3px;
    margin-right: 8px;
}

.hub-tournament-matches-widget__matches__match-team img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 8px;
}

.hub-tournament-matches-widget__matches__match-team.baloa-names {
    color: var(--primary-very-dark-color);
}

.hub-tournament-matches-widget__matches__match-team-score {
    margin-left: auto;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    
    .hub-tournament-matches-widget__matches-container{
        display: block;
    }

    .hub-tournament-matches-widget__tournament_info img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
    }

    .hub-tournament-matches-widget__matches__match {
        padding: 8px;
        border-radius: 0;
        border: unset;
        border-bottom: 1px solid var(--new-gray-background-color);
    }

    .hub-tournament-matches-widget__matches__match-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .hub-tournament-matches-widget__matches__match-teams-info {
        display: flex;
        align-items: center;
        width: 100%;
    }
    
    .hub-tournament-matches-widget__matches__match-team {
        width: 50%;
        justify-content: flex-start;
        margin-top: 6px;
    }

    .hub-tournament-matches-widget__matches__match-team:first-child {
        justify-content: flex-end;
    }

    .hub-tournament-matches-widget__matches__match-team img {
        width: 24px;
        height: 24px;
        margin: 0 7px;
    }

    .hub-tournament-matches-widget__matches__match-team .icon-ball {
        font-size: 20px;    
        padding: 2px;
        margin: 0 7px;
    }

    .hub-tournament-matches-widget__tournament_info {
        background-color: var(--new-background-color);
        border-radius: 2px;
        width: fit-content;
        padding: 2px;
    }

    .hub-tournament-matches-widget__tournament_info img {
        width: 12px;
        height: 12px;
        margin-right: 3px;
    }
    
    .hub-tournament-matches-widget__tournament_info .icon-ball {
        color: var(--white-color );
        font-size: 8px;
        padding: 2px;
        margin-right: 3px;
    }

    .hub-tournament-matches-widget__matches__match-date {
        margin-top: 0;
    }

    .hub-tournament-matches-widget__matches__match-date.baloa-table-column {
        color: var(--primary-very-dark-color);
        font-weight: var(--font-regular);
    }

    .hub-tournament-matches-widget__matches__match-state {
        padding: 2px;
        border-radius: 2px;
        width: fit-content;
        background: var(--basic-gray-color);
    }

    .hub-tournament-matches-widget__matches__match-state.baloa-table-column {
        color: var(--white-color);
        font-weight: var(--font-regular);        
    }

    .hub-tournament-matches__empty {
        margin: 50px;
        width: auto;
    }
    .hub-tournament-matches__empty img{
        width: -webkit-fill-available;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/hub-tournament-matches-widget/HubTournamentMatchesWidgetComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;;yBAEqB;IACrB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;AACrB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,yDAAyD;IAC7D;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,UAAU;QACV,2BAA2B;QAC3B,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,6CAA6C;QAC7C,kBAAkB;QAClB,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;QAC1B,cAAc;QACd,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,qCAAqC;QACrC,gCAAgC;IACpC;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,mCAAmC;IACvC;;IAEA;QACI,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,6BAA6B;IACjC;AACJ","sourcesContent":[".hub-tournament-matches-widget__container {\n    margin-bottom: var(--space-x2);\n}\n\n.hub-tournament-matches-widget__matches-container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n}\n\n.hub-tournament-matches-widget__matches__match {\n    padding: 10px 12px;\n    border-radius: 8px;\n    background: var(--white-color);\n}\n\n.hub-tournament-matches-widget__tournament_info {\n    display: flex;\n    align-items: center;\n    /* background: var(--new-background-color);\n    padding: 2px 4px;\n    border-radius: 2px; */\n    cursor: pointer;\n}\n\n.hub-tournament-matches-widget__tournament_info img {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    margin-right: 4px;\n}\n\n.hub-tournament-matches-widget__tournament_info .icon-ball {\n    color: var(--white-color );\n    font-size: 18px;\n    border-radius: 50%;\n    padding: 2px;\n    margin-right: 4px;\n}\n\n.hub-tournament-matches-widget__tournament_info .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.hub-tournament-matches-widget__matches__match-date {\n    background-color: var(--new-background-color);\n    border-radius: 2px;\n    width: fit-content;\n    padding: 2px;\n    margin-top: 6px;\n    cursor: pointer;\n}\n\n.hub-tournament-matches-widget__matches__match-date.baloa-username {\n    color: var(--primary-very-dark-color);\n}\n\n.hub-tournament-matches-widget__matches__match-team {\n    display: flex;\n    align-items: center;\n    margin-top: 10px;\n    cursor: pointer;\n}\n\n.hub-tournament-matches-widget__matches__match-team .icon-ball {\n    color: var(--white-color );\n    font-size: 24px;\n    border-radius: 50%;\n    padding: 3px;\n    margin-right: 8px;\n}\n\n.hub-tournament-matches-widget__matches__match-team img {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    margin-right: 8px;\n}\n\n.hub-tournament-matches-widget__matches__match-team.baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.hub-tournament-matches-widget__matches__match-team-score {\n    margin-left: auto;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    \n    .hub-tournament-matches-widget__matches-container{\n        display: block;\n    }\n\n    .hub-tournament-matches-widget__tournament_info img {\n        width: 16px;\n        height: 16px;\n        margin-right: 4px;\n    }\n\n    .hub-tournament-matches-widget__matches__match {\n        padding: 8px;\n        border-radius: 0;\n        border: unset;\n        border-bottom: 1px solid var(--new-gray-background-color);\n    }\n\n    .hub-tournament-matches-widget__matches__match-info {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .hub-tournament-matches-widget__matches__match-teams-info {\n        display: flex;\n        align-items: center;\n        width: 100%;\n    }\n    \n    .hub-tournament-matches-widget__matches__match-team {\n        width: 50%;\n        justify-content: flex-start;\n        margin-top: 6px;\n    }\n\n    .hub-tournament-matches-widget__matches__match-team:first-child {\n        justify-content: flex-end;\n    }\n\n    .hub-tournament-matches-widget__matches__match-team img {\n        width: 24px;\n        height: 24px;\n        margin: 0 7px;\n    }\n\n    .hub-tournament-matches-widget__matches__match-team .icon-ball {\n        font-size: 20px;    \n        padding: 2px;\n        margin: 0 7px;\n    }\n\n    .hub-tournament-matches-widget__tournament_info {\n        background-color: var(--new-background-color);\n        border-radius: 2px;\n        width: fit-content;\n        padding: 2px;\n    }\n\n    .hub-tournament-matches-widget__tournament_info img {\n        width: 12px;\n        height: 12px;\n        margin-right: 3px;\n    }\n    \n    .hub-tournament-matches-widget__tournament_info .icon-ball {\n        color: var(--white-color );\n        font-size: 8px;\n        padding: 2px;\n        margin-right: 3px;\n    }\n\n    .hub-tournament-matches-widget__matches__match-date {\n        margin-top: 0;\n    }\n\n    .hub-tournament-matches-widget__matches__match-date.baloa-table-column {\n        color: var(--primary-very-dark-color);\n        font-weight: var(--font-regular);\n    }\n\n    .hub-tournament-matches-widget__matches__match-state {\n        padding: 2px;\n        border-radius: 2px;\n        width: fit-content;\n        background: var(--basic-gray-color);\n    }\n\n    .hub-tournament-matches-widget__matches__match-state.baloa-table-column {\n        color: var(--white-color);\n        font-weight: var(--font-regular);        \n    }\n\n    .hub-tournament-matches__empty {\n        margin: 50px;\n        width: auto;\n    }\n    .hub-tournament-matches__empty img{\n        width: -webkit-fill-available;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
